import { GetServerSideProps } from 'next';
import { GeolinkHomePageFieldsFragment, GeolinkInformationFieldsFragment } from 'api/graphql-types';
import Layout from 'modules/layout/layout';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import client from 'api/apollo-client';
import { getServerPageGetGeolinkHome } from 'api/graphql-helper';
import { initialState as settingsInitialState } from 'redux/stores/settings';
import { Head } from 'modules/head/head';
import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import HomepageHeader from 'modules/homepage-header/homepage-header';
import { ROUTES } from 'constants/routes';
import { IBasePageProps } from 'types/page';

interface IGeolinkPageProps extends IBasePageProps {
	geolinkHomepage?: GeolinkHomePageFieldsFragment;
	geolinkInformation?: GeolinkInformationFieldsFragment;
}

const GeolinkHomePage = (props: IGeolinkPageProps): React.JSX.Element => {
	const modules = props.geolinkHomepage?.modules;
	const seoModule = props?.geolinkHomepage?.seo;

	return (
		<Layout navbar={props?.geolinkInformation?.navbar} footer={props?.geolinkInformation?.footer}>
			<Head seoModule={seoModule} seoParent={props?.geolinkInformation?.seo} />
			<HomepageHeader module={props?.geolinkHomepage?.header} />
			<ModuleBuilder modules={modules} slug={ROUTES.HOME.fullPath} />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps<IBasePageProps> = async (ctx) => {
	try {
		const { locale, publicationState, draftMode } = getStrapiParametersFromContext(ctx);

		const geolinkHomePageResult = await getServerPageGetGeolinkHome(
			{
				variables: {
					locale,
					publicationState
				}
			},
			client
		);
		const { geolinkHomepage, geolinkInformation } = geolinkHomePageResult.props.data;

		return {
			props: {
				geolinkHomepage: geolinkHomepage?.data?.attributes,
				geolinkInformation,
				initialReduxState: {
					settings: {
						...settingsInitialState,
						publicationState,
						draftMode,
						contentType: 'op-oost-homepage',
						contentTypeId: geolinkHomepage?.data?.documentId,
						showNeutralStyle: true,
						hideLanguageSwitcher: true,
						hideSearchbar: true,
						isSubsite: true
					}
				}
			}
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('error in GeolinkHomepage', error);
		return {
			notFound: true
		};
	}
};

export default GeolinkHomePage;
